import { render } from "./ListWithDelete.vue?vue&type=template&id=5d21c553&scoped=true"
import script from "./ListWithDelete.vue?vue&type=script&lang=js"
export * from "./ListWithDelete.vue?vue&type=script&lang=js"

import "./ListWithDelete.vue?vue&type=style&index=0&id=5d21c553&scoped=true&lang=css"
import "./ListWithDelete.vue?vue&type=style&index=1&id=5d21c553&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d21c553"]])

export default __exports__